import axios from 'axios'
import { FipeBrand, FipeModel, FipeYear } from '../types/fipe'

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000'

class VehicleService {
    /**
     * Busca todas as marcas disponíveis no backend local
     */
    async getBrands(): Promise<FipeBrand[]> {
        try {
            const response = await axios.get(`${API_URL}/api/vehicles/brands`)
            return response.data.data.brands
        } catch (error) {
            console.error('Erro ao buscar marcas:', error)
            throw error
        }
    }

    /**
     * Busca os modelos de uma marca
     */
    async getModels(brandCode: string): Promise<FipeModel[]> {
        try {
            const response = await axios.get(`${API_URL}/api/vehicles/models/${brandCode}`)
            return response.data.data.models
        } catch (error) {
            console.error(`Erro ao buscar modelos da marca ${brandCode}:`, error)
            throw error
        }
    }

    /**
     * Busca os anos de um modelo
     */
    async getYears(brandCode: string, modelCode: string): Promise<FipeYear[]> {
        try {
            const response = await axios.get(`${API_URL}/api/vehicles/years/${brandCode}/${modelCode}`)
            return response.data.data.years
        } catch (error) {
            console.error(`Erro ao buscar anos do modelo ${modelCode}:`, error)
            throw error
        }
    }

    /**
     * Busca as baterias compatíveis
     */
    async getCompatibleBatteries(brand: string, model: string, year: string): Promise<any[]> {
        try {
            const response = await axios.get(`${API_URL}/api/vehicles/compatible-batteries`, {
                params: { brand, model, year }
            })
            return response.data.data.batteries
        } catch (error) {
            console.error('Erro ao buscar baterias compatíveis:', error)
            throw error
        }
    }
}

export const vehicleService = new VehicleService()
export default vehicleService
